<!--sidebar-text-light: bg-asteroid | bg-vicious-stance|bg-midnight-bloom|bg-night-sky|bg-slick-carbon|bg-royal|bg-grow-early
bg-premium-dark| bg-success | bg-warning | bg-primary | bg-navy-blue | bg-secondary | bg-dark | bg-alternate-->
<div class="app-sidebar sidebar-shadow bg-navy-blue sidebar-text-light">
  <div class="app-header__logo">
    <!-- <div class="logo-src"></div> -->
    <div class="header__pane ml-auto">
      <div>
        <button type="button" class="hamburger close-sidebar-btn hamburger--elastic" data-class="closed-sidebar">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
      </div>
    </div>
  </div>
  <div class="app-header__mobile-menu">
    <div>
      <button type="button" class="hamburger hamburger--elastic mobile-toggle-nav">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
    </div>
  </div>
  <div class="app-header__menu">
    <span>
      <button type="button" class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav">
        <span class="btn-icon-wrapper">
          <i class="fa fa-ellipsis-v fa-w-6"></i>
        </span>
      </button>
    </span>
  </div>
  <div class="scrollbar-sidebar">
    <div class="app-sidebar__inner">
      <!---------New menu code below--------->

      <div id="accordian">
        <ul class="vertical-nav-menu">
          <li>
            <a href="javascript:void(0);" (click)="goToPage('/configurationList')" class="mm-active"
              [ngClass]="{'mm-active':activeRoute === 'configurationList'}"> <!--(click)="toggleItem('/dashboard')" -->
              <!-- <i class="metismenu-icon pe-7s-rocket"></i> -->
              <img class="menu-icon " src="/assets/images/project-assets-images/new-application.png" />
              <span>Manage Configuration</span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0);" (click)="goToPage('/deviceList')" class=""
              [ngClass]="{'mm-active':activeRoute === 'deviceList'}">
              <img class="menu-icon " src="/assets/images/project-assets-images/to-do-list.png" />
              <span>Devices</span>
            </a>
          </li>
          <!-- <li>
            <a href="javascript:void(0);" (click)="goToPage('/dashboard')" class=""
              [ngClass]="{'mm-active':activeRoute === 'dashboard'}">
              <img class="menu-icon " src="/assets/images/project-assets-images/home.png" />
              <span>Dashboard</span>
            </a>
          </li> -->

          <li>
            <a href="javascript:void(0);" (click)="goToPage('/dataTable')" class=""
              [ngClass]="{'mm-active':activeRoute === 'dataTable'}"> <!--(click)="toggleItem('/dashboard')" -->
              <!-- <i class="metismenu-icon pe-7s-rocket"></i>  -->
              <img class="menu-icon " src="/assets/images/project-assets-images/all-application.png" />
              <span>Data Tables</span>
            </a>
          </li>
          <li>
            <a href="javascript:void(0);" (click)="goToPage('/dashboard')" class=""
              [ngClass]="{'mm-active':activeRoute === 'dashboard'}"> <!--(click)="toggleItem('/dashboard')" -->
              <!-- <i class="metismenu-icon pe-7s-rocket"></i> -->
              <img class="menu-icon " src="/assets/images/project-assets-images/home.png" />
              <span>Data Charts</span>
            </a>
          </li>



        </ul>
      </div>

    </div>
  </div>
</div>